export const COUNTRY_OPTIONS = [
  ['Other', 0],
  ['United States', 1],
  ['Bahamas', 2],
  ['Canada', 3],
  ['Mexico', 4],
  ['Turkey', 5],
  ['Australia', 6],
  ['Switzerland', 7],
  ['France', 8],
  ['Monaco', 9],
  ['Spain', 10],
  ['United Kingdom', 11],
  ['Germany', 12],
  ['Italy', 13],
  ['Poland', 14],
  ['Romania', 15]
];

const STATE_OPTIONS = {
  1: { // United States
    AL: 'Alabama',
    AK: 'Alaska',
    AZ: 'Arizona',
    AR: 'Arkansas',
    CA: 'California',
    CO: 'Colorado',
    CT: 'Connecticut',
    DE: 'Delaware',
    DC: 'District of Columbia',
    FL: 'Florida',
    GA: 'Georgia',
    HI: 'Hawaii',
    ID: 'Idaho',
    IL: 'Illinois',
    IN: 'Indiana',
    IA: 'Iowa',
    KS: 'Kansas',
    KY: 'Kentucky',
    LA: 'Louisiana',
    ME: 'Maine',
    MD: 'Maryland',
    MA: 'Massachusetts',
    MI: 'Michigan',
    MN: 'Minnesota',
    MS: 'Mississippi',
    MO: 'Missouri',
    MT: 'Montana',
    NE: 'Nebraska',
    NV: 'Nevada',
    NH: 'New Hampshire',
    NJ: 'New Jersey',
    NM: 'New Mexico',
    NY: 'New York',
    NC: 'North Carolina',
    ND: 'North Dakota',
    OH: 'Ohio',
    OK: 'Oklahoma',
    OR: 'Oregon',
    PA: 'Pennsylvania',
    PR: 'Puerto Rico',
    RI: 'Rhode Island',
    SC: 'South Carolina',
    SD: 'South Dakota',
    TN: 'Tennessee',
    TX: 'Texas',
    UT: 'Utah',
    VT: 'Vermont',
    VA: 'Virginia',
    WA: 'Washington',
    WV: 'West Virginia',
    WI: 'Wisconsin',
    WY: 'Wyoming'
  },
  3: { // Canada
    BC: 'British Columbia',
    AB: 'Alberta',
    SK: 'Saskatchewan',
    MB: 'Manitoba',
    ON: 'Ontario',
    QC: 'Quebec',
    NB: 'New Brunswick',
    NL: 'Newfoundland/Labrador',
    NS: 'Nova Scotia',
    PE: 'Prince Edward Island',
    NT: 'Northwest Territories',
    NU: 'Nunavut',
    YT: 'Yukon Territory'
  },
  4: { // Mexico
    AGU: 'Aguascalientes',
    BCN: 'Baja California Norte',
    BCS: 'Baja California Sur',
    CAM: 'Campeche',
    CHP: 'Chiapas',
    CHH: 'Chihuahua',
    COA: 'Coahuila',
    COL: 'Colima',
    CMX: 'Ciudad de México',
    DUR: 'Durango',
    MEX: 'Estado de México',
    GUA: 'Guanajuato',
    GRO: 'Guerrero',
    HID: 'Hidalgo',
    JAL: 'Jalisco',
    MIC: 'Michoacán',
    MOR: 'Morelos',
    NAY: 'Nayarit',
    NLE: 'Nuevo León',
    OAX: 'Oaxaca',
    PUE: 'Puebla',
    QEU: 'Querétaro',
    ROO: 'Quintana Roo',
    SLP: 'San Luis Potosí',
    SIN: 'Sinaloa',
    SON: 'Sonora',
    TAB: 'Tabasco',
    TAM: 'Tamaulipas',
    TLA: 'Tlaxcala',
    VER: 'Veracruz',
    YUC: 'Yucatán',
    ZAC: 'Zacatecas'
  },
  6: { // Australia
    ACT: 'Australian Capital Territory',
    NSW: 'New South Wales',
    NT: 'Northern Territory',
    QLD: 'Queensland',
    SA: 'South Australia',
    TAS: 'Tasmania',
    VIC: 'Victoria',
    WA: 'Western Australia'
  },
  7: { // Switzerland
    AG: 'Aargau',
    AI: 'Appenzell Innerrhoden',
    AR: 'Appenzell Ausserrhoden',
    BE: 'Bern',
    BL: 'Basel-Landschaft',
    BS: 'Basel-Stadt',
    FR: 'Fribourg',
    GE: 'Geneva',
    GL: 'Glarus',
    GR: 'Graubünden',
    JU: 'Jura',
    LU: 'Luzern',
    NE: 'Neuchâtel',
    NW: 'Nidwalden',
    OW: 'Obwalden',
    SG: 'St. Gallen',
    SH: 'Schaffhausen',
    SO: 'Solothurn',
    SZ: 'Schwyz',
    TG: 'Thurgau',
    TI: 'Ticino',
    UR: 'Uri',
    VD: 'Vaud',
    VS: 'Valais',
    ZG: 'Zug',
    ZH: 'Zürich'
  },
  13: { // Italy
    AG: 'Agrigento',
    AL: 'Alessandria',
    AN: 'Ancona',
    AO: 'Aosta',
    AR: 'Arezzo',
    AP: 'Ascoli Piceno',
    AT: 'Asti',
    AV: 'Avellino',
    BA: 'Bari',
    BT: 'Barletta-Andria-Trani',
    BL: 'Belluno',
    BN: 'Benevento',
    BG: 'Bergamo',
    BI: 'Biella',
    BO: 'Bologna',
    BZ: 'South Tyrol',
    BS: 'Brescia',
    BR: 'Brindisi',
    CA: 'Cagliari',
    CL: 'Caltanissetta',
    CB: 'Campobasso',
    CI: 'Carbonia-Iglesias',
    CE: 'Caserta',
    CT: 'Catania',
    CZ: 'Catanzaro',
    CH: 'Chieti',
    CO: 'Como',
    CS: 'Cosenza',
    CR: 'Cremona',
    KR: 'Crotone',
    CN: 'Cuneo',
    EN: 'Enna',
    FM: 'Fermo',
    FE: 'Ferrara',
    FI: 'Florence',
    FG: 'Foggia',
    FC: 'Forlì-Cesena',
    FR: 'Frosinone',
    GE: 'Genoa',
    GO: 'Gorizia',
    GR: 'Grosseto',
    IM: 'Imperia',
    IS: 'Isernia',
    SP: 'La Spezia',
    AQ: 'L\'Aquila',
    LT: 'Latina',
    LE: 'Lecce',
    LC: 'Lecco',
    LI: 'Livorno',
    LO: 'Lodi',
    LU: 'Lucca',
    MC: 'Macerata',
    MN: 'Mantua',
    MS: 'Massa and Carrara',
    MT: 'Matera',
    VS: 'Medio Campidano',
    ME: 'Messina',
    MI: 'Milan',
    MO: 'Modena',
    MB: 'Monza and Brianza',
    NA: 'Naples',
    NO: 'Novara',
    NU: 'Nuoro',
    OG: 'Ogliastra',
    OT: 'Olbia-Tempio',
    OR: 'Oristano',
    PD: 'Padua',
    PA: 'Palermo',
    PR: 'Parma',
    PV: 'Pavia',
    PG: 'Perugia',
    PU: 'Pesaro and Urbino',
    PE: 'Pescara',
    PC: 'Piacenza',
    PI: 'Pisa',
    PT: 'Pistoia',
    PN: 'Pordenone',
    PZ: 'Potenza',
    PO: 'Prato',
    RG: 'Ragusa',
    RA: 'Ravenna',
    RC: 'Reggio Calabria',
    RE: 'Reggio Emilia',
    RI: 'Rieti',
    RN: 'Rimini',
    RM: 'Rome',
    RO: 'Rovigo',
    SA: 'Salerno',
    SS: 'Sassari',
    SV: 'Savona',
    SI: 'Siena',
    SO: 'Sondrio',
    SR: 'Syracuse',
    TA: 'Taranto',
    TE: 'Teramo',
    TR: 'Terni',
    TP: 'Trapani',
    TN: 'Trentino',
    TV: 'Treviso',
    TS: 'Trieste',
    TO: 'Turin',
    UD: 'Udine',
    VA: 'Varese',
    VE: 'Venice',
    VB: 'Verbano-Cusio-Ossola',
    VC: 'Vercelli',
    VR: 'Verona',
    VV: 'Vibo Valentia',
    VI: 'Vicenza',
    VT: 'Viterbo'
  }
};

export function getStateOptions(countryId) {
  const stateListObj = STATE_OPTIONS[countryId];
  const stateList = [];

  if (stateListObj) {
    for (const [key, value] of Object.entries(stateListObj)) {
      stateList.push([`${key} - ${value}`, key]);
    }
  }

  return stateList;
}

export function stateFieldLabel(countryId) {
  let label = 'State';
  switch (countryId) {
  case '0':
  case '3':
  case '10':
  case '13':
    label = 'Province';
    break;
  case '2':
    label = 'Island';
    break;
  case '5':
    label = 'District';
    break;
  case '6':
    label = 'State/Territory';
    break;
  case '7':
    label = 'Canton';
    break;
  case '8':
    label = 'Region';
    break;
  case '9':
    label = 'Ward';
    break;
  case '14':
    label = 'State/Province';
    break;
  case '15':
    label = 'District/County';
    break;
  }
  return label;
}
